module.exports = __webpack_public_path__ + "img/dota-logo.108d9226.svg";